<template>
  <div class="rt-detail-bottom">
    <template v-if="$slots.custom">
      <slot name="custom"></slot>
    </template>
    <template v-else>
      <div class="left">
        <rt-row
          v-for="(row, index) in content"
          :key="index"
        >
          <rt-col
            v-for="(col, index2) in row.attrs"
            :key="index2"
            :span="col.span"
            :align="col.align"
          >
            <rt-text
              :label="col.label"
              :text="col.text"
              :light="col.light"
              type="primary"
            />
          </rt-col>
        </rt-row>
      </div>
      <div class="right">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
import RtRow from '../../row/rtRow.vue';
import RtCol from '../../col/rtCol.vue';
import RtText from '../common/rtAttr.vue';
export default {
  name: 'RtDetailBottom',
  components: { RtRow, RtCol, RtText },
  props: {
    content: {
      type: Array
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailBottom.vue?1fb7d522